import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 注册 Service Worker，启用离线功能和智能缓存
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ Service Worker 安装成功，应用已支持离线访问');
  },
  onUpdate: (registration) => {
    console.log('🔄 检测到新版本，正在更新...');
    // 自动更新到最新版本
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }
});

